import {
  Avatar,
  Box,
  Button,
  Card,
  Container,
  Grid,
  TextField,
} from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { CircularProgress } from "@mui/material";
import BookingApi from "../../API/Apis/BookingApi";
import NotAuthorisedPage from "../notAuthorisedPage";
import { BookingGetters } from "../../store/onlineBooking/getters";
import { t } from "i18next";
import BookingDetalisListSideNavigation from "../../components/Layouts/ReservationsCard/BookingDetalisListSideNavigation";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogActions from "@mui/material/DialogActions";
import { AppStandardButton } from "../../components/UI/AppButtons";
import { createTheme } from "@mui/material/styles";
import { formatTheme } from "../../config/MuiColorThemes";
import CollapsibleNavbar from "../../components/Layouts/ReservedAreaDashboard/CollapseNavbar";

export function Profile() {
  const appSettings = BookingGetters?.getAppSettings();
  const dynamicPalette = formatTheme();
  const dynamicTheme = createTheme(dynamicPalette);
  const isSmallScreen = window.innerWidth <= 768;
  useEffect(() => {
    const id: any = localStorage.getItem("userID");
    BookingApi.getUserProfileByUserId(id).then((e) => {
      setProfileDetails(e.data.onlineUser[0]);
    });
  }, []);
  const [isUpdatingProfilePic, setIsUpdatingProfilePic] =
    useState<boolean>(false);
  const [profileDetails, setProfileDetails] = useState<any>({
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
    userImage: "",
    profile_picture: null as File | null,
  });
  const [isError, setIsError] = useState(false);
  const fileInputRef = useRef<HTMLInputElement>(null);

  // function handleSubmit(event) {
  //   const id: any = localStorage.getItem("userID");
  //   event.preventDefault();
  //   BookingApi.UpdateUserProfileById(id, profileDetails).then((e) => {
  //     if (e.data.status) {
  //       setModalMessage("User Updated Successfully");
  //       setOpenModal(true);
  //     } else {
  //       setModalMessage("Unable to Update");
  //       setOpenModal(true);
  //       window.location.reload();
  //     }
  //     return e.data;
  //   });
  // }

  function handleSubmit(): void {
    setIsUpdatingProfilePic(true);
    const id = localStorage.getItem("userID");

    if (!id) {
      setModalMessage("User ID not found");
      setOpenModal(true);
      return;
    }
    if (
      !profileDetails.firstName ||
      !profileDetails.lastName ||
      !profileDetails.email
    ) {
      setIsError(true);
      return;
    }
    BookingApi.UpdateUserProfileById(id, profileDetails)
      .then((e) => {
        if (e && e.status) {
          setIsUpdatingProfilePic(false);
          setModalMessage("User Updated Successfully");
          BookingApi.getUserProfileByUserId(Number(id)).then((e) => {
            setProfileDetails(e.data.onlineUser[0]);
          });
        } else {
          setIsUpdatingProfilePic(false);
          setModalMessage("Unable to Update");
        }
        setOpenModal(true);
      })
      .catch((err) => {
        setIsUpdatingProfilePic(false);
        console.error("Error in update:", err);
        setModalMessage("Error occurred during update");
        setOpenModal(true);
      });
  }

  const handleReset = (): void => {
    setProfileDetails({
      firstName: "",
      lastName: "",
      email: "",
      phoneNumber: "",
      profile_picture: null as File | null,
    });
  };
  const reservedAreaSection = appSettings && {
    ...appSettings,
    reservedArea: true,
  };
  const [showReserve, setShowReserve] = useState<boolean>(
    !!appSettings?.reservedArea
  );
  useEffect(() => {
    BookingApi.getAppSetting().then((e) => {
      setShowReserve(e.reservedArea);
    });
  }, [showReserve]);

  const handlePhoneNo = (event) => {
    setProfileDetails({ ...profileDetails, phoneNumber: event.target.value });
  };
  const handleFirstName = (event) => {
    setProfileDetails({ ...profileDetails, firstName: event.target.value });
  };
  const handleLastName = (event) => {
    setProfileDetails({ ...profileDetails, lastName: event.target.value });
  };
  const [openModal, setOpenModal] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const requestOnClose = () => {
    setOpenModal(false);
    setModalMessage("");
  };
  const istabletScreen = window.innerWidth > 768 && window.innerWidth < 1300;

  return (
    <div className="flex-row md:flex">
      {reservedAreaSection && !isSmallScreen && !istabletScreen && (
        <div className="!w-780" style={{ width: "300px" }}>
          <BookingDetalisListSideNavigation />
        </div>
      )}
      {reservedAreaSection && (isSmallScreen || istabletScreen) && (
        <CollapsibleNavbar callFrom="showProfile" />
      )}
      {reservedAreaSection ? (
        <div className="flex flex-col pt-0 md:pt-12">
          <div
            className={`text-[#333] mb-4  ${
              isSmallScreen
                ? "ml-5 w-[94%]"
                : "ml-16 whitespace-nowrap w-[300px]"
            }`}
          >
            <h1 className="text-[28px] font-normal">
              {t("Account information")}
            </h1>
            <h3 className="text-[20px] text-[#838181]">
              {t(
                "Your account information is here you can edit your details from here"
              )}
            </h3>
          </div>
          {isUpdatingProfilePic ? (
            <Box
              sx={{
                display: "flex",
                width: "100%",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <CircularProgress />
            </Box>
          ) : (
            <div className={`${!isSmallScreen ? "ml-[30px]" : "ml-0"}`}>
              <Container component="main" maxWidth="xs">
                <Card sx={{ minWidth: !isSmallScreen ? 600 : 0 }}>
                  <Grid
                    container
                    spacing={0}
                    direction="column"
                    alignItems="center"
                    justifyContent="center"
                    boxShadow={3}
                  >
                    <Grid item xs={3}>
                      <Grid container alignItems="center">
                        <Card sx={{ minWidth: !isSmallScreen ? 440 : 300 }}>
                          <Box
                            sx={{
                              // marginBottom: 1,
                              padding: 2,
                              display: "flex",
                            }}
                          >
                            {/* Hidden file input */}
                            <input
                              type="file"
                              accept="image/png, image/jpeg"
                              className="hidden"
                              ref={fileInputRef}
                              name="profile_picture"
                              onChange={(e) => {
                                const file = e?.target?.files?.[0];
                                if (file) {
                                  if (
                                    file.type !== "image/png" &&
                                    file.type !== "image/jpeg"
                                  ) {
                                    alert("Only PNG & JPEG files are allowed.");
                                    e.target.value = "";
                                    return;
                                  }

                                  setProfileDetails({
                                    ...profileDetails,
                                    userImage: file
                                      ? URL.createObjectURL(file)
                                      : "",
                                    profile_picture: file || null,
                                  });
                                }
                              }}
                            />
                            {!isSmallScreen && (
                              <div className="flex">
                                <label style={{ cursor: "pointer" }}>
                                  <Avatar
                                    onClick={() =>
                                      fileInputRef.current?.click()
                                    }
                                    src={
                                      profileDetails.userImage ||
                                      profileDetails.profile_picture ||
                                      "/assets/images/AvtarProfilePage.png"
                                    }
                                    sx={{
                                      margin: 2,
                                      width: 70,
                                      height: 70,
                                    }}
                                  />
                                </label>
                              </div>
                            )}
                            <div className="">
                              {isSmallScreen && (
                                <div className="justify-center">
                                  <Avatar
                                    src={
                                      profileDetails?.userImage ||
                                      profileDetails?.profile_picture ||
                                      "/assets/images/AvtarProfilePage.png"
                                    }
                                    sx={{
                                      margin: 2,
                                      width: 70,
                                      height: 70,
                                    }}
                                  />
                                </div>
                              )}
                              <TextField
                                margin="normal"
                                required
                                fullWidth
                                label={t("First Name")}
                                value={profileDetails?.firstName}
                                name="firstName"
                                onChange={handleFirstName}
                              />
                              {!profileDetails?.firstName && isError && (
                                <span className="text-red-600 mb-2">
                                  Please fill the First Name..!
                                </span>
                              )}
                              <TextField
                                margin="normal"
                                required
                                fullWidth
                                name="lastName"
                                label={t("Last Name")}
                                value={profileDetails?.lastName}
                                id="lastName"
                                onChange={handleLastName}
                              />
                              {!profileDetails?.lastName && isError && (
                                <span className="text-red-600 mb-2">
                                  Please fill the Last Name..!
                                </span>
                              )}
                              <TextField
                                margin="normal"
                                required
                                fullWidth
                                label={t("Email")}
                                disabled={true}
                                name="email"
                                value={profileDetails?.email}
                                id="email"
                              />
                              <TextField
                                name="phoneNumber"
                                id="phoneNumber"
                                value={profileDetails?.phoneNumber}
                                margin="normal"
                                required
                                fullWidth
                                label={t("Phone Number")}
                                onChange={handlePhoneNo}
                              />
                              {!profileDetails?.phoneNumber && isError && (
                                <span className="text-red-600 mb-2">
                                  Please fill the Phone Number ..!
                                </span>
                              )}
                              <div className="flex gap-4 flex-row-reverse mt-2">
                                <Button
                                  onClick={handleSubmit}
                                  type="submit"
                                  variant="contained"
                                  sx={{
                                    gap: 3,
                                    fontWeight: "bold",
                                    bgcolor:
                                      dynamicTheme?.palette["primary"]?.main,
                                    textTransform: "capitalize",
                                  }}
                                  style={{
                                    backgroundColor:
                                      dynamicTheme?.palette["primary"]?.main,
                                  }}
                                >
                                  {t("Save")}
                                </Button>

                                <Button
                                  onClick={handleReset}
                                  type="submit"
                                  variant="outlined"
                                  sx={{
                                    gap: 3,
                                    fontWeight: "bold",
                                    borderColor: "#000",
                                    textTransform: "capitalize",
                                  }}
                                  style={{ color: "#000" }}
                                >
                                  {t("Cancel")}
                                </Button>
                              </div>
                            </div>
                          </Box>
                        </Card>
                      </Grid>
                    </Grid>
                  </Grid>
                </Card>
              </Container>
            </div>
          )}
        </div>
      ) : (
        <NotAuthorisedPage />
      )}
      <Dialog
        open={openModal}
        onClose={requestOnClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        PaperProps={{ style: { borderRadius: "20px" } }}
      >
        <DialogTitle style={{ padding: "3rem" }}>{modalMessage}</DialogTitle>

        <DialogActions>
          <AppStandardButton variant="outlined" onClick={requestOnClose}>
            <p className="text-black normal-case">Close</p>
          </AppStandardButton>
        </DialogActions>
      </Dialog>
    </div>
  );
}
